import React from 'react';
import { SubmitButton, AfterSubmitFunc, usePopupManager } from 'ui-builder';
import BaseEventTaskForm from './BaseEventTaskForm';
import {
  PlanTask,
  PlanTaskParentTaskRelation,
  usePlanTasksService
} from 'nekst-api';
import { PopupForm } from 'features/nekst-widgets';

export interface CreateEventTaskFormProps {
  planId: number,
  afterSubmitFunc?: AfterSubmitFunc,
  parentTask?: PlanTask
  isProceeding?: boolean,
}

export function CreateEventTaskForm(props: CreateEventTaskFormProps) {
  const planTaskService = usePlanTasksService();

  let initialData: PlanTask = {} as PlanTask;

  if (props.parentTask) {
    initialData = {
      ...initialData,
      parentTaskRelation: {
        parentTaskId: props.parentTask.id,
        parentTaskName: props.parentTask.name,
        isProceeding: props.isProceeding,
      } as PlanTaskParentTaskRelation,
    } as PlanTask;
  }

  const getTitle = () => {
    if (props.parentTask) {
      if (props.isProceeding) {
        return 'Add Proceeding Appointment Task';
      } else {
        return 'Add Dependent Appointment Task';
      }
    } else {
      return 'Add Appointment Task';
    }
  }

  return (
    <BaseEventTaskForm
      title={getTitle()}
      planId={props.planId}
      submitFormFunc={
        (data) => {
          return planTaskService.createEventTask(props.planId, data);
        }
      }
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={planTaskService.getEventTaskValidationSchema()}
      buttons={<SubmitButton text="Save task" key="save" />}
      initialData={initialData}
    />
  );
}

export default function useCreateEventTaskForm() {
  const popupManager = usePopupManager();

  const openForm = (planId: number) => {
    popupManager.openPopup(
      <PopupForm>
        <CreateEventTaskForm planId={planId} />
      </PopupForm>,
    );
  };

  return {
    openForm,
  };
}
